<template>
  <v-dialog v-model="show" width="40vw" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable persistent>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        Fecha entrega en producción
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="loteForm" lazy-validation>
            <v-row no-gutters>
              <v-col cols="12">
                <v-text-field label="Ingrese fecha" dense outlined clearable :rules="validation()" type="date"
                  v-model="date"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn color="red" block @click="closeModal()" dark :disabled="isLoading">Cancelar</v-btn>
            </v-col>
            <v-col>
              <v-btn color="primary" block @click="confirmation" :loading="isLoading">Agregar fecha</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapMutations, mapState } from "vuex";
//axios
import axios from "axios";
//validations
import { requiredValidation, requiredMultiple } from "@/helpers/validations.js";
export default {
  data: () => ({
    isLoading: false,
    user: JSON.parse(localStorage.getItem("user")),
    date: null,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("order", ["deliveryToUpdate"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  mounted() {
    this.date = this.deliveryToUpdate.deliveryProductionDate
  },
  methods: {
    ...mapActions("order", ["setDateDelivery"]),
    ...mapMutations("order", ["SET_DELIVERY_OP_TO_UPDATE","SET_CALENDAR_NEW_EVENT"]),
    closeModal() {
      this.SET_DELIVERY_OP_TO_UPDATE(null);
      this.show = false;
    },
    async confirmation() {
      //emit fetch table
      if (this.$refs.loteForm.validate()) {
        try {
          this.isLoading = true;
          let payload = {
            date: this.date,
            deliveryId: this.deliveryToUpdate._id,
          };

          let response = await this.setDateDelivery(payload);
          if (response) {
            this.$swal({
              icon: "success",
              title: `Fecha agregada`,
              showConfirmButton: false,
              timer: 500,
            });
            this.SET_CALENDAR_NEW_EVENT(this.date)
            this.$emit("update");
            this.closeModal()
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al agregar fecha`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (e) {
          console.log(e);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al agregar fecha`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoading = false;
      }
    },

    validation(name) {
      return requiredValidation(name);
    },
  },
};
</script>

<style scoped>
.decrease {
  background-color: red;
  color: white;
}
</style>
